/**
 * The founding-client discount.
 *
 * Renders nothing at all when LAUNCH_OFFER_OPEN is false — the whole section,
 * not a greyed-out version of it. An expired offer left visible on a site is
 * worse than no offer, because it dates the page and invites someone to ask
 * for a price that is no longer real.
 *
 * The three points exist because a 30% discount invites suspicion. Each one
 * answers the obvious question: what am I giving up, who controls what gets
 * published, and what happens if it goes badly.
 */
import { Button } from '../components/Button';
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import { LAUNCH_OFFER_OPEN } from '../lib/constants';
import styles from './Offer.module.css';

export function Offer() {
  const { t } = useI18n();

  if (!LAUNCH_OFFER_OPEN) return null;

  return (
    <Section tone="ink">
      <div className={styles.layout}>
        <div className={styles.copy}>
          <h2 className={styles.title}>{t.offer.title}</h2>
          <p className={styles.body}>{t.offer.body}</p>
          <Button variant="onInk" size="lg" href="#proposal">
            {t.offer.cta}
          </Button>
        </div>

        <ul className={styles.points}>
          {t.offer.points.map((point) => (
            <li key={point.title} className={styles.point}>
              <h3 className={styles.pointTitle}>{point.title}</h3>
              <p className={styles.pointBody}>{point.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
